import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "dotHorizontalFilled"
const DotHorizontalFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M5.625 9.75C6.868 9.75 7.875 10.757 7.875 12S6.868 14.25 5.625 14.25 3.375 13.243 3.375 12 4.382 9.75 5.625 9.75M12 9.75C13.243 9.75 14.25 10.757 14.25 12S13.243 14.25 12 14.25 9.75 13.243 9.75 12 10.757 9.75 12 9.75M18.375 9.75C19.618 9.75 20.625 10.757 20.625 12S19.618 14.25 18.375 14.25 16.125 13.243 16.125 12 17.132 9.75 18.375 9.75" />
        </svg>
      }
    </span>
  )
}
export default DotHorizontalFilledIcon
